export class EditCollectionRequest {
	products: Array<string>;
}
